import products from '../../../data/products'

const state = {
  productslist: products.data,
  products: products.data,
  currency: { curr: 'usd', symbol: '$'},
  order: [],
  locale: 'en',
  loaded:false,
}
// getters
const getters = {
  getLoaded:state=>{
    return state.loaded
  },
  getcollectionProduct: (state) => {
    return collection => state.products.filter((product) => {
      return collection === product.collection
    })
  },
  getProductById: (state) => id => {
    for(let group of state.products) {
      var product = group.products.find((obj)=> obj.id === +id)
      if(product) return product
    }
    return {}
  },
  getProductByProductId:(state)=>productId=>{
    for(let group of state.products) {
      var product = group.products.find((obj)=> obj.productId === +productId)
      if(product) return product
    }
    return {}
  },
  changeCurrency: (state) => {
    if (state.currency.curr === 'usd') {
      state.currency.curr = 0.01
      return state.currency
    }
  },
  getOrder: (state) => {
    return state.order
  }
}
// mutations
const mutations = {
  setProducts:(state,payload)=>{
    state.products = payload
    state.productslist = payload
    state.loaded = true
  },
  changeCurrency: (state, payload) => {
    state.currency = payload
  },
  createOrder: (state, payload) => {
    state.order = payload
  }
}
// actions
const actions = {
  setProducts:(context,payload) =>{
    context.commit('setProducts',payload)
  },
  changeCurrency: (context, payload) => {
    context.commit('changeCurrency', payload)
  },
  createOrder: (context, payload) => {
    context.commit('createOrder', payload)
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
